import { ThemeProvider as NextThemesProvider } from "next-themes";
import { ReactNode, useEffect } from "react";
import { useTheme } from "next-themes";

interface ThemeProviderProps {
  children: ReactNode;
  storageKey?: string;
}

/** Keeps <meta name="theme-color"> in sync with the resolved theme so the
 *  mobile browser/PWA status bar matches manual overrides too. */
function ThemeMetaSync() {
  const { resolvedTheme } = useTheme();
  useEffect(() => {
    const dark = resolvedTheme === "dark";
    const color = dark ? "#0A0E1A" : "#FAFAFF";
    document.documentElement.style.colorScheme = dark ? "dark" : "light";
    let meta = document.querySelector('meta[name="theme-color"]') as HTMLMetaElement | null;
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "theme-color";
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", color);
  }, [resolvedTheme]);
  return null;
}

export function ThemeProvider({ children, storageKey = "theme" }: ThemeProviderProps) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      themes={["light", "dark"]}
      storageKey={storageKey}
      disableTransitionOnChange
    >
      <ThemeMetaSync />
      {children}
    </NextThemesProvider>
  );
}
